import React, { PureComponent, PropTypes } from 'react';
import InlineSVG from 'svg-inline-react';
import { camelCaseToHyphenCase } from 'utils/utils';

import adultChildIcon from './images/AdultChild.svg';
import infantIcon from './images/Infant.svg';
import hoverIcon from './images/EmptySeatHover.svg';

import './PassengerSeat.scss';

export default class PassengerSeat extends PureComponent {
  static propTypes = {
    counter: PropTypes.number,
    paxType: PropTypes.string.isRequired,
    hover: PropTypes.bool,
  };

  static defaultProps = {
    counter: undefined,
    hover: false,
  };

  COUNTER_X_COORD_FOR_ADULT_ICON = 50;
  COUNTER_X_COORD_FOR_INFANT_ICON = 45;

  COUNTER_Y_COORD_FOR_ALL_ICONS = 71;

  render() {
    const { paxType, counter, hover } = this.props;
    let iconSrc;

    if (hover) {
      iconSrc = hoverIcon;
    } else {
      iconSrc = paxType === 'adultWithInfant' ? infantIcon : adultChildIcon;
    }

    const modifier = camelCaseToHyphenCase(paxType);
    const counterX = paxType === 'adultWithInfant' ? this.COUNTER_X_COORD_FOR_INFANT_ICON : this.COUNTER_X_COORD_FOR_ADULT_ICON;
    const counterY = this.COUNTER_Y_COORD_FOR_ALL_ICONS;

    return (
      <div className={`passenger-seat passenger-seat--${modifier} ${hover ? 'passenger-seat--hover' : 'passenger-seat--normal'}`}>
        <InlineSVG className={`passenger-seat__icon passenger-seat__icon--${modifier}`} src={iconSrc} />
        { counter !== undefined && (
          <span className="passenger-seat__counter-icon">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0" y="0" width="100" height="100" viewBox="0 0 100 100" enableBackground="new 0 0 100 100">
              <text fontSize="22" x={counterX} y={counterY} textAnchor="middle">{counter}</text>
            </svg>
          </span>
        )}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/PassengerSeat.jsx
 **/